"use client";

import { Award, Info } from "lucide-react";

import { NextEventCard } from "./NextEventCard";

interface EventCardProps {
  groupId: string;
}

export function CourtOfHonorCard({ groupId }: EventCardProps) {
  return (
    <NextEventCard
      groupId={groupId}
      tags={["ceremony", "court-of-honor"]}
      title="Next Court of Honor"
      subtitle="Honoring the hard work of our Scouts"
      eventType="ceremony"
      colorScheme="scout-matrix-yellow"
      icon={Award}
      fallbackTitle="No upcoming Court of Honor"
      fallbackDescription="Check our calendar for the latest ceremony schedule."
      fallbackLocation="Location TBD"
      fallbackAudience="Scouts and Families"
      detailsUrl={groupId === "400G" ? "/400G/court-of-honor" : undefined}
      detailsLinkText="View Details"
    />
  );
}

export function TroopMeetingCard({ groupId }: EventCardProps) {
  return (
    <NextEventCard
      groupId={groupId}
      tags={["meeting", "troop-meeting"]}
      title="Next Troop Meeting"
      subtitle="Weekly Troop Meeting"
      eventType="meeting"
      colorScheme="scout-matrix-green"
      icon={Info}
      fallbackTitle="No upcoming meeting found"
      fallbackDescription="Check our calendar for the latest meeting schedule. We typically meet weekly on Monday evenings."
      fallbackLocation="Chestnut Grove Church - Downstairs Classroom"
      fallbackAudience="Scouts"
    />
  );
}

export function PackMeetingCard({ groupId }: EventCardProps) {
  return (
    <NextEventCard
      groupId={groupId}
      tags={["ceremony", "pack-meeting"]}
      title="Next Pack Meeting"
      subtitle="Monthly gathering with dinner and awards"
      eventType="ceremony"
      colorScheme="scout-matrix-yellow"
      icon={Award}
      fallbackTitle="No upcoming Pack Meeting found"
      fallbackDescription="Check our calendar for the latest pack meeting schedule."
      fallbackLocation="Chestnut Grove Church - Fellowship Hall"
      fallbackAudience="Cubs and Families"
      detailsUrl="/cubscouts/pack-meeting/food-signup"
      detailsLinkText="Food Signup"
    />
  );
}

export function DenMeetingCard({ groupId }: EventCardProps) {
  return (
    <NextEventCard
      groupId={groupId}
      tags={["meeting", "den-meeting"]}
      title="Next Den Meeting"
      subtitle="Weekly den meeting with activities"
      eventType="meeting"
      colorScheme="scout-blue"
      icon={Info}
      fallbackTitle="No upcoming Den Meeting found"
      fallbackDescription="Check our calendar for the latest den meeting schedule."
      fallbackLocation="Chestnut Grove Church"
      fallbackAudience="Cubs and Families"
    />
  );
}
